import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { oth, googleProvider } from "../firebase";
import { FaGoogle } from "react-icons/fa";

const LogIn = () => {
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),

    onSubmit: async (values) => {
      try {
        const user = await createUserWithEmailAndPassword(
          oth,
          values.email,
          values.password
        );
        console.log(user);
      } catch (error) {
        console.log(error);
      }
    },
  });

  const googleLogIn = async () => {
    try {
      const user = await signInWithPopup(oth, googleProvider);
      console.log(user);
    } catch (error) {}
  };

  return (
    <div>
      <section
        className="page-title-section overlay"
        style={{ backgroundImage: "url(images/backgrounds/page-title.jpg)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <ul className="list-inline custom-breadcrumb mb-2">
                <li className="list-inline-item">
                  <a
                    className="h2 text-primary font-secondary"
                    href="index.html"
                  >
                    Admin
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="section bg-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="section-title">LogIn</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7 mb-4 mb-lg-0">
              <form onSubmit={formik.handleSubmit} method="POST">
                <div>
                  <input
                    type="email"
                    className="form-control mb-3"
                    id="email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Email"
                    required
                  />
                  <span className="ml-4">
                    {formik.touched.email && formik.errors.email
                      ? formik.errors.email
                      : ""}
                  </span>
                </div>

                <div>
                  <input
                    type="password"
                    className="form-control mb-3"
                    id="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Password"
                  />
                  <span className="ml-4">
                    {formik.touched.password && formik.errors.password
                      ? formik.errors.password
                      : ""}
                  </span>
                </div>

                <button type="submit" value="send" className="btn btn-primary">
                  SignIn
                </button>
                <button
                  type="button"
                  className="btn btn-primary ml-2"
                  onClick={googleLogIn}
                >
                  SignIn With <FaGoogle />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="section pt-0">
        <div
          id="map_canvas"
          data-latitude="51.507351"
          data-longitude="-0.127758"
        ></div>
      </section>
    </div>
  );
};

export default LogIn;
